export default {
  default: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/layouts/default.vue").then(m => m.default || m)
}